import 'angular';
/**
 * Templates
 */
import modalTemplate from '../../../../shared/templates/modals/generic_modal.template.html?raw';
import bookmarkedSearchIntervalTemplate from './bookmarked_search_interval_modal.template.html?raw';
/**
 * Bookmarked Search model and dependencies
 */
import '../../../../../../lib/assets/javascripts/devex/angular/models/bookmarked-search';
import 'angular-resource';
import '../../../../../../lib/assets/javascripts/devex/angular/request_transformers';
/**
 * Bookmarked Search service and dependencies
 */
import '../../models/bookmarked_search_service';
import '../../../../../../lib/assets/javascripts/devex/browser_url';
import '../../../../../../lib/assets/javascripts/devex/urls';
import 'lodash';
/**
 * AngularJS filters
 */
import '../../../../../../lib/assets/javascripts/devex/angular/filters/bookmarked_search_ownership';
import '../../../../../../lib/assets/javascripts/devex/angular/filters/my_alert';
import '../../../../../../lib/assets/javascripts/devex/util.js';
/**
 * UI bootstrap
 */
import modal from 'angular-ui-bootstrap/src/modal';
/**
 * Other dependencies
 */
import '../../../../../../lib/assets/javascripts/devex/alerts';

angular
  .module('directives.bookmarkedSearches', [
    // Reused bookmarkedSearch model
    'models.bookmarkedSearch',
    // Reused bookmarked Search Service
    'models.bookmarkedSearchService',
    // Reused AngularJS filters
    'filters.myBookmarkedSearches',
    'filters.sharedBookmarkedSearches',
    'filters.myAlert',
    // UI Bootstrap modal
    modal,
    // Module Directives
    'directives.bookmarkedSearchesList',
    'directives.bookmarkedSearchesCreate',
    'directives.bookmarkedSearchesEdit',
  ])
  .run(['$templateCache', function($templateCache) {
    $templateCache.put(modalTemplate, modalTemplate);
    $templateCache.put(bookmarkedSearchIntervalTemplate, bookmarkedSearchIntervalTemplate);
  }])
  .directive('bookmarkedSearches', [
    function () {
      return {
        controller: 'BookmarkedSearchController',
        restrict: 'E',
        transclude: true,
        scope: {
          searchJs: '=',
          toggleCreateAlertPanel: '<',
          exitAppliedAlert: '<',
          userSignedIn: '<',
          fundingUpdatedSinceAggregations: '<?',
          dateFilterService: '<?',
        },
        link: function (scope, element, attrs, ctrls, $transclude) {
          $transclude(scope, function (clone) {
            element.append(clone);
          });
        },
      };
    },
  ])
  .controller('BookmarkedSearchController', [
    '$scope',
    '$uibModal',
    'bookmarkedSearchService',
    '$filter',
    'BookmarkedSearch',
    function (scope, $uibModal, bookmarkedSearchService, $filter, BookmarkedSearch) {
      const search_type = 'funding_projects';
      scope.bookmarkedSearchService = bookmarkedSearchService;

      scope.resetBookmarkedSearchModel = function () {
        scope.bookmarkedSearchModel = {
          title: '',
          interval: '',
        };
      };

      scope.bookmarkedSearches = [];

      var intervalModal = null;
      scope.createModal = null;
      scope.genericModal = null;

      var genericModalSettings = {
        animation: false,
        templateUrl: modalTemplate,
        scope: scope,
        show: false,
        backdrop: 'static',
      };

      /**
       * Uses $uibModal lib to display a modal, asking for confirmation before user deletes alert
       *
       * @param {Object} bookmarkedSearch - Whole bookmarked search object
       *
       * @returns {undefined}
       */
      scope.showDeleteModal = function (bookmarkedSearch) {
        scope.bookmarkedSearchModel = angular.copy(bookmarkedSearch);

        scope.genericModalOptions = {
          title: 'Delete alert',
          hide: scope.hideDeleteModal,
          confirm: function () {
            scope.removeBookmarkedSearch();
          },
          body:
            'Are you sure you\'d like to delete the alert for "' +
            scope.bookmarkedSearchModel.title +
            '"?',
          cancelText: 'Cancel',
          confirmText: 'Confirm',
        };

        scope.genericModal = $uibModal.open(genericModalSettings);
      };

      /**
       * Checks if alert passed as arg belongs to current user
       *
       * @param {Object} bookmark - Whole bookmarked search object
       *
       * @returns {boolean} True if alert belongs to user, false if not
       */
      scope.isMyBookmark = function (bookmark) {
        return devex.data.user.id === bookmark.consultant_id;
      };

      scope.hideDeleteModal = function () {
        scope.resetBookmarkedSearchModel();
        scope.genericModal.close();
      };

      /**
       * When in Edit mode, refresh the active bookmark so that the changes to bookmark or alerts
       * are being reflected.
       *
       * @param {number} bookmarkId - ID of the bookmarked search
       * @returns {undefined}
       */
      scope.refreshActiveBookmark = function (bookmarkId) {
        scope.bookmarkedSearchService.active = scope.bookmarkedSearches.filter(function (bookmark) {
          return bookmark.id === bookmarkId;
        })[0];
      };

      /**
       * Toggle the frequency of the current user alert, placed under the bookmarked search
       *
       * @param {Object} bookmarkedSearch - Whole bookmarked search object
       *
       * @returns {undefined}
       */
      scope.toggleAlertFrequency = function (bookmarkedSearch) {
        var myAlert = $filter('myAlert')(bookmarkedSearch.alerts);
        if (myAlert) {
          var intervalAsInteger = myAlert.how_often === 1 ? 7 : 1;
          BookmarkedSearch.updateAlert(
            { alert_id: myAlert.id },
            { interval: intervalAsInteger },
            function (alertResponse) {
              scope.reload().then(function () {
                if (scope.bookmarkedSearchService.active.id) {
                  scope.refreshActiveBookmark(alertResponse.alertable_id);
                }
                devex.alerts.showAlert(
                  '"' + bookmarkedSearch.title + '" frequency has been successfully modified',
                  'success'
                );
              });
            },
            function () {
              // Error callback
              devex.alerts.showAlert('Sorry, something went wrong. Please try again.', 'error');
            }
          );
        }
      };

      /**
       * The Confirm alert creation button will be enabled when:
       * - There is an active SearchJS filter selected
       * - variable bookmarkedSearchModel (used as model for bookmark creation) has a title
       * - variable bookmarkedSearchModel (used as model for bookmark creation) has an interval
       *
       * @returns {boolean} True when the confirm alert creation will be enabled, false when it
       *                    should be disabled
       */
      scope.isCreateButtonEnabled = function () {
        return (
          scope.searchJs &&
          scope.bookmarkedSearchModel &&
          !!Object.keys(scope.searchJs.getFilterValues()).length &&
          scope.bookmarkedSearchModel.title.length &&
          scope.bookmarkedSearchModel.interval &&
          scope.bookmarkedSearchModel.interval.length
        );
      };

      /**
       * Update bookmarked search, if there is a date filter in the params, we will not send that
       * date over to the BE, perform PATCH request with the params and perform certain actions on
       * success or failure.
       *
       * @returns {undefined}
       */
      scope.updateBookmarkedSearch = function () {
        scope.bookmarkedSearchService.active.saving = true;
        var params = {
          search_type,
          title: scope.bookmarkedSearchService.active.title,
        };
        params.params = scope.searchJs.getParams({
          includeFilter: true,
          includeSorting: true,
        });

        var bookmarkWithDate = scope.containsDateFilter(params.params.filter);

        if (bookmarkWithDate) {
          scope.deleteDateFilters(params.params.filter);
        }

        BookmarkedSearch.updateBookmarkSearch(
          { id: scope.bookmarkedSearchService.active.id },
          params
        ).$promise.then(
          function (updatedSavedSearch) {
            // Success Callback
            scope.bookmarkedSearchService.active = angular.copy(updatedSavedSearch);
            scope.reload();
            scope.bookmarkedSearchService.active.saving = false;
            if (bookmarkWithDate) {
              devex.alerts.showAlert(
                'Please note that the dates you have selected can be used ' +
                  'while searching, but are not saved.',
                'info'
              );
            } else {
              devex.alerts.showAlert('You have successfully updated your alert', 'success');
            }
          },
          function () {
            // Error callback
            scope.bookmarkedSearchService.active.saving = false;
            devex.alerts.showAlert(
              'An error occurred while saving "' + scope.bookmarkedSearchService.active.title + '"',
              'error'
            );
          }
        );
      };

      scope.removeBookmarkedSearch = function () {
        scope.bookmarkedSearchModel.$delete(
          { id: scope.bookmarkedSearchModel.id },
          function () {
            // Success callback
            scope.genericModal.close();
            scope.reload();
            devex.alerts.showAlert(
              '"' + scope.bookmarkedSearchModel.title + '" has been removed from your alerts.',
              'success'
            );
            scope.resetBookmarkedSearchModel();
            scope.bookmarkedSearchService.active = {};
          },
          function () {
            // Error callback
            scope.genericModal.close();
            devex.alerts.showAlert(
              'An error occurred while removing "' + scope.bookmarkedSearchModel.title + '"',
              'error'
            );
            scope.resetBookmarkedSearchModel();
          }
        );
      };

      /**
       * When user clicks on the Edit button of one of the bookmarked searches, show expanded
       * Edition panel and trigger SearchJS.
       *
       * @param {Object} bookmarkedSearch - Whole bookmarked search object
       * @returns {undefined}
       */
      scope.editBookmark = function (bookmarkedSearch) {
        scope.bookmarkedSearchService.alertSectionOptions.isEditionExpanded = true;
        scope.bookmarkedSearchService.alertSectionOptions.isBookmarkedSearchApplied = true;
        scope.activateBookmark(bookmarkedSearch);
      };

      /**
       * When user selects a bookmarked search by clicking on its title in list, do not show
       * the expanded Edition panel, update UI with the selected bookmark and trigger SearchJS.
       *
       * @param {Object} bookmarkedSearch - Whole bookmarked search object
       *
       * @returns {undefined}
       */
      scope.selectBookmark = function (bookmarkedSearch) {
        scope.bookmarkedSearchService.alertSectionOptions.isEditionExpanded = false;
        scope.bookmarkedSearchService.alertSectionOptions.isBookmarkedSearchApplied = true;

        scope.activateBookmark(bookmarkedSearch);
      };

      /**
       * In order to activate an alert, set selected alert as active by copying it to
       * bookmarkedSearchService.active, minimize List panel and reload SearchJS
       *
       * @param {Object} bookmarkedSearch - Whole bookmarked search object
       *
       * @returns {undefined}
       */
      scope.activateBookmark = function (bookmarkedSearch) {
        scope.bookmarkedSearchService.alertSectionOptions.isListExpanded = false;
        scope.bookmarkedSearchService.active = angular.copy(bookmarkedSearch);
        scope.bookmarkedSearchService.reloadSearchJs(scope.searchJs);
      };

      /**
       * Query to get all existing bookmarked searches of the user (and also shared with the user)
       *
       * @returns {Promise} Promise that can be extended by using then(), catch()...
       */
      scope.reload = function () {
        return BookmarkedSearch.query(
          {
            search_type,
            'page[size]': 300,
          },
          function (result) {
            scope.bookmarkedSearches = result;

            if (!scope.bookmarkedSearchService.triggerSearchJs) {
              var whiteListedParams = ['updated_since', 'type'];

              // On first page load, container directive won't trigger SearchJs
              // search() until this boolean is turned to true
              scope.bookmarkedSearchService.finishInit(
                scope.bookmarkedSearches,
                scope.searchJs,
                whiteListedParams
              );
            }
          },
          function () {
            devex.alerts.showAlert(
              'We were not able to load the alerts. Please try again.',
              'error'
            );
          }
        ).$promise;
      };

      scope.dateFilterKeys = ['deadline', 'updated_since'];

      scope.containsDateFilter = function (filterParams) {
        if (filterParams) {
          return scope.dateFilterKeys.some(function (dateFilterKey) {
            return filterParams[dateFilterKey];
          });
        }
        return false;
      };

      scope.deleteDateFilters = function (filterParams) {
        scope.dateFilterKeys.forEach(function (dateFilterKey) {
          delete filterParams[dateFilterKey];
        });
      };

      /**
       * Save bookmark search
       *
       * @returns {undefined}
       */
      scope.saveBookmarkedSearch = function () {
        var params = {
          title: scope.bookmarkedSearchModel.title,
          search_type,
        };
        params.params = scope.searchJs.getParams({
          includeFilter: true,
          includeSorting: true,
        });
        var selectedInterval = scope.bookmarkedSearchModel.interval;
        var bookmarkWithDate = scope.containsDateFilter(params.params.filter);

        if (bookmarkWithDate) {
          scope.deleteDateFilters(params.params.filter);
        }

        new BookmarkedSearch(params).$save(
          function (bookmarkedSearch) {
            // Success callback
            scope.bookmarkedSearchModel = angular.copy(bookmarkedSearch);
            scope.activateAlertAfterBookmarkCreation(selectedInterval, bookmarkWithDate);
          },
          function () {
            // Error callback
            scope.resetBookmarkedSearchModel();
            scope.bookmarkedSearchService.alertSectionOptions.isCreationExpanded = false;
            devex.alerts.showAlert(
              'An error occurred while saving "' + params.title + '"',
              'error'
            );
          }
        );
      };

      /**
       * Function that acts as a toggle to activate/deactivate an alert.
       *
       * @param {Object} bookmarkedSearch - Whole bookmarked search object
       *
       * @returns {undefined}
       */
      scope.toggleAlertActivation = function (bookmarkedSearch) {
        var myAlert = $filter('myAlert')(bookmarkedSearch.alerts);
        if (myAlert) {
          BookmarkedSearch.deleteAlert(
            { alert_id: myAlert.id },
            function (alertResponse) {
              // Success callback
              scope.reload().then(function () {
                if (scope.bookmarkedSearchService.active.id) {
                  scope.refreshActiveBookmark(alertResponse.alertable_id);
                }
                scope.resetBookmarkedSearchModel();
              });
            },
            function () {
              // Error callback
              devex.alerts.showAlert(
                'An error occurred while deactivating "' + bookmarkedSearch.title + '"',
                'error'
              );
              scope.resetBookmarkedSearchModel();
            }
          );
        } else {
          scope.bookmarkedSearchModel = angular.copy(bookmarkedSearch);

          intervalModal = $uibModal.open({
            templateUrl: bookmarkedSearchIntervalTemplate,
            scope: scope,
            animation: false,
          });
        }
      };

      /**
       * After bookmark creation, create alert for it.
       *
       * @param {string} alertInterval - Either `daily` or `weekly`
       * @param {boolean} bookmarkContainsDate - Used to notify user if its bookmark contained dates
       * @returns {undefined}
       */
      scope.activateAlertAfterBookmarkCreation = function (alertInterval, bookmarkContainsDate) {
        BookmarkedSearch.activateAlert(
          {
            alertable_type: 'BookmarkedSearch',
            alertable_id: scope.bookmarkedSearchModel.id,
            interval: alertInterval === 'daily' ? 1 : 7,
          },
          function (alertResponse) {
            // Success callback
            scope.reload().then(function () {
              if (bookmarkContainsDate) {
                devex.alerts.showAlert(
                  'Please note that the dates you have selected can be used ' +
                    'while searching, but are not saved.',
                  'info'
                );
              } else {
                devex.alerts.showAlert(
                  'You have successfully created an alert for "' +
                    scope.bookmarkedSearchModel.title +
                    '"',
                  'success'
                );
              }

              var newBookmark = scope.bookmarkedSearches.filter(function (bookmark) {
                return bookmark.id === alertResponse.alertable_id;
              })[0];

              scope.selectBookmark(newBookmark);
              scope.bookmarkedSearchService.alertSectionOptions.isCreationExpanded = false;
              scope.resetBookmarkedSearchModel();
            });
          },
          function () {
            // Error callback
            devex.alerts.showAlert('Sorry, something went wrong. Please try again.', 'error');
            scope.resetBookmarkedSearchModel();
          }
        );
      };

      /**
       * Activate alert of an existing bookmark (done via the interval modal)
       *
       * @param {string} alertInterval - Either `daily` or `weekly`
       * @returns {undefined}
       */
      scope.activateAlert = function (alertInterval) {
        var intervalAsInteger = alertInterval === 'daily' ? 1 : 7;

        BookmarkedSearch.activateAlert(
          {
            alertable_type: 'BookmarkedSearch',
            alertable_id: scope.bookmarkedSearchModel.id,
            interval: intervalAsInteger,
          },
          function (alertResponse) {
            // Success callback
            scope.reload().then(function () {
              if (scope.bookmarkedSearchService.active.id) {
                scope.refreshActiveBookmark(alertResponse.alertable_id);
              }
              intervalModal.close();
              scope.resetBookmarkedSearchModel();
            });
          },
          function () {
            // Error callback
            scope.resetBookmarkedSearchModel();
            devex.alerts.showAlert('Sorry, something went wrong. Please try again.', 'error');
            intervalModal.close();
          }
        );
      };

      var finishInitWithDevexUser = function () {
        scope.isLinkedToCompany = devex.user.isLinkedToCompany;
        scope.resetBookmarkedSearchModel();
        scope.reload();
      };

      /**
       * If user is signed in, fetch additional user data before requesting user's bookmarked
       * searches
       *
       * @returns {undefined}
       */
      scope.init = function () {
        scope.$watch('userSignedIn', function (present) {
          if (present) {
            devex.user.getData(finishInitWithDevexUser);
          }
        });
      };

      scope.init();
    },
  ]);
